// extracted by mini-css-extract-plugin
module.exports = {"list":"Naave3IMwLby3hR5kTxR7"};